import React from "react";
import { Link } from "react-router-dom";
import $ from "jquery";
import UserStore from "../../common/user-store";
import logo from "../../assets/img/RamLogo.png";
import * as AuthAPI from "../../api/auth.api";
import * as StudentProfilesAPI from "../../api/admin-student-profiles-api";
import * as HelperService from "../../common/helper";
import LoaderOverlay from '../../components/shared/loader';

class Login extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            form: this.getEmptyModel(),
            passwordError: false,
            emailError: false,
            errMessage: '',
            loading: false
        };
    }

    getEmptyModel = () => {
        return {
            emailId: "",
            password: ""
        };
    };

    componentDidMount() {
        window.scroll({ top: 0, left: 0, behavior: "smooth" });
    }

    handleKeyDown= event=>{
        if (event.key === 'Enter') {
            this.handleSubmit();
          }
    }

    handleSubmit = event => {
        event && event.preventDefault();
        const { form } = this.state;
        let model = HelperService.makeCopy(form);

        this.setState({ form }, () => {
            // main validation-handle
            if (form.emailId === "" || form.password === "" || !HelperService.matchEmailFormat(form.emailId)) {
                $("form").addClass("was-validated");
            } else {
                this.setState({ loading: true });
                AuthAPI.login(model).then(
                    response => {
                        this.setState({ loading: false });
                        let data = response.data.loginResult;
						data.token = response.data.token;
                        UserStore.set(data);
                        if(UserStore.loggedin()){
                            
                            if (data.roleId === 2) {
                                // this.getStudentId();
                                this.props.history.push("/dashboard")
                            }
                            else {
                                this.props.history.push("/admin/dashboard")
                            }    
                        }
                    },
                    error => {
                        let errMessage = error && error.data ? error.data.message : "Could not login. Please try again.";
                        errMessage?.includes('email') ? this.setState({ errMessage, emailError: true }) : this.setState({ errMessage, passwordError: true })
                        this.setState({ loading: false });
                    }
                );
            }
        });
    };

    getStudentId = () => {
        let userId = UserStore.get("id");

        StudentProfilesAPI.getStudentProfile(userId).then(
            response => {
                this.setState({ loading: false });

                let studentDetails = response.data && response.data.data;
                UserStore.let('studentDetail', studentDetails[0]);
                this.props.history.push("/dashboard");
            },
            error => {
                this.setState({ loading: false });
            }
        )
    }

    handleReset = () => {
        $("form")
            .removeClass("was-validated")
            .get(0)
            .reset();
        $("html,body").animate({ scrollTop: 0 }, 400);
        this.setState({
            form: this.getEmptyModel()
        });
    };

    render() {
        const { form, errMessage, loading } = this.state;

        return (
            <div className="login-main d-flex align-items-center">
                <LoaderOverlay active={loading} />
                <div className="login-wrap px-0 bg-white">
                    <div className="row mx-auto px-0">
                        <div className="col-12 col-md-6 d-none d-md-block px-0 position-relative">
                            <div className="login-banner" />
                            <div className="login-banner-overlay"></div>
                            <div className="login-banner-text text-center">
                                <h4 className="text-white font-weight-bold">Welcome to RAM Foundation</h4>
                                <p className="text-white p-3">To register with us please sign up with your personal details.</p>
                                <Link to="/student-registration">
                                    <input
                                        type="button"
                                        className="btn button bg-transparent border z-depth-0 border-white my-1 px-4 px-md-5 mx-auto"
                                        value="Sign Up" />
                                </Link>
                            </div>

                        </div>
                        <div className="col-12 col-md-6 px-3 px-md-5 py-4 bg-white login-div">
                            <div className="text-center">
                                <img
                                    src={logo}
                                    className="header-brand-img mb-0 mx-auto"
                                    alt="RAM Foundation"
                                    style={{ height: "80px" }}
                                />
                            </div>
                            <input
                                id="tab1"
                                type="radio"
                                name="tab"
                                className="sign-in mx-auto"
                                checked
                            />
                            <label
                                htmlFor="tab-1"
                                className="tab text-capitalize px-1 mr-1 mb-3 border-left border-danger d-flex justify-content-left font-weight-bold"
                            >
                                Sign In
            </label>
                            <input id="tab2" type="radio" name="tab" className="sign-up d-none" />
                            <label htmlFor="tab-2" className="tab d-none">
                                Sign Up
            </label>
                            <form id="loginForm">
                                <div className="login-form">
                                    <div className="sign-in-htm">
                                        <div className="form-group group">
                                            <label htmlFor="emailId" className="label mb-1 text-capitalize">
                                                Email ID
                    </label>
                                            <input
                                                id="emailId"
                                                type="email"
                                                placeholder="Enter Email ID"
                                                className="input form-control"
                                                required
                                                value={form.emailId || ""}
                                                onChange={event => {
                                                    form.emailId = event.target.value;
                                                    this.setState({ emailError: false, form });
                                                }}
                                            />
                                            <div className="invalid-feedback">
                                                Email address is required.
                    </div>
                                            {this.state.emailError &&
                                                <div className="invalid-feedback d-block">
                                                    {errMessage}
                                                </div>
                                            }

                                        </div>
                                        <div className="form-group group">
                                            <label htmlFor="pass" className="label mb-1 text-capitalize">
                                                Password
                    </label>
                                            <input
                                                id="pass"
                                                type="password"
                                                placeholder="Enter Password"
                                                className="input form-control"
                                                data-type="password"
                                                required
                                                value={form.password || ""}
                                                onKeyDown={this.handleKeyDown}
                                                onChange={event => {
                                                    form.password = event.target.value;
                                                    this.setState({ passwordError: false, form });
                                                }}
                                            />
                                            <div className="invalid-feedback">
                                                Password is required.
                      </div>
                                            {this.state.passwordError &&
                                                <div className="invalid-feedback d-block">
                                                    {errMessage}
                                                </div>
                                            }
                                        </div>

                                        <div className="text-right">
                                            <Link to="/forgot-password">
                                                I can't remember my password
                    </Link>
                                        </div>
                                        <div className="group text-center my-2 my-md-3">
                                            <input
                                                type="button"
                                                className="btn button login-submit-btn waves-effect waves-light my-1 px-4 px-md-5 mx-auto"
                                                value="Sign In"
                                                onClick={event => {
                                                    this.handleSubmit(event);
                                                }}
                                            />
                                        </div>
                                        <div className="text-center d-block d-md-none">
                                            <Link to="/student-registration">Not a member? Sign Up</Link>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Login;
